<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-text=""
      v-model="filterModel"
    >
      <div class="d-flex align-items-start mt-1 ml-3">
        <action-button
          id="process-sie-assistence-search"
          i="fa fa-sync pr-2"
          variant="success px-3"
          @click="onProcessHandler"
        >
          Procesar
        </action-button>
      </div>
    </filter-manager>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import ActionButton from 'ActionButton'
import AcademicYearServices from '@/services/api/academicyear.api'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  name: 'SieAssistance',
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
    },
    filterModel: {
      academicYear: null,
      studentSieId: null,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Consulta de Asistencia en SIE',
        routes: ['Informe', 'Consulta de Asistencia en SIE'],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          options: this.filterOptions.academicYears,
        },
        {
          name: 'studentSieId',
          component: 'CustomInput',
          class: 'col-12 col-md-3',
          placeholder: 'Escriba número de SIE',
          icon: 'fa fa-search orange-icon',
          value: this.filterModel.studentSieId,
          leftIcon: true,
          type: 'number',
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYearAttendance()
      ).data
      this.filterModel.academicYear = this.filterOptions.academicYears[0]
    },
    async onProcessHandler() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport('sieattendance', {
        academicYearId: this.filterModel.academicYear.id,
        studentSieId: this.filterModel?.studentSieId,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
